import { render, staticRenderFns } from "./PayrollForm.vue?vue&type=template&id=5ba73441&"
import script from "./PayrollForm.vue?vue&type=script&lang=js&"
export * from "./PayrollForm.vue?vue&type=script&lang=js&"
import style0 from "./PayrollForm.vue?vue&type=style&index=0&id=5ba73441&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports